import { render, staticRenderFns } from "./UserApplicants.vue?vue&type=template&id=35e9ff8b"
import script from "./UserApplicants.vue?vue&type=script&lang=js"
export * from "./UserApplicants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports